// extracted by mini-css-extract-plugin
export default {"title":"HotelAirportDetails_title__Vvxv1","total":"HotelAirportDetails_total__fUdxU","edit":"HotelAirportDetails_edit__d6iF-"};